import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import { ApplicationPaths,navigateToStep } from "../ApplicationFormsHelpers";
import { useApplicationIdContext } from "../../components/ApplicationContext";
import {
    waitForUploadSucess,
} from "../../services/legacyApplicationApiService";
import {
    ErrorMessage,
    Headline,
    Hero,
} from "../../ui";
import { SignCommonComponent, useApplicationSignContext } from "../../components/Sign/SignCommon";
import style from "./style.module.scss";
import { CommonStatusPageProps } from "@n2-common/components/ApplicationStatusPage";
import { useSearchParams } from "react-router-dom";
import { logErrorToServerside, logInfoToServerSide } from "@n2-common/services/serverSideLogging";

function SblCompleted({navigateToCorrectStepFunc}: CommonStatusPageProps): JSX.Element {
    return <SignCommonComponent navigateToCorrectStepFunc={navigateToCorrectStepFunc}>
        <SblCompletedInner/>
    </SignCommonComponent>
}

function SblCompletedInner(): JSX.Element {
    const navigate = useNavigate();

    const { applicantId, applicationId, isMainApplicant} = useApplicationSignContext();
    const { country, productType } = useApplicationIdContext();
    const [errorMsg, setErrorMsg] = useState<string |null>(null); 
    const [searchParams] = useSearchParams();
    const documentGuids = searchParams.get("docGuids");
    if (documentGuids) {
        console.log(documentGuids);
    }

    useEffect(()  => {
        const docs = documentGuids?.split(";") || [];
        waitForUploadSucess(docs, applicationId, applicantId).then(()  => {
            logInfoToServerSide("Got all SBL-documents, redirecting to front of sign-page", applicationId, applicantId);
            navigateToStep(ApplicationPaths.sign, applicationId, navigate, applicantId);
         }).catch(() => {
            setErrorMsg("Noe gikk galt. Prøv på nytt senere, eller last opp dokumentet manuelt");
            logErrorToServerside("failed waiting for SBL-documents", applicationId, applicantId, docs);
         })
    }, [applicationId, navigate, applicantId, isMainApplicant, productType, country, documentGuids]);

    return (
        <>
        <span className={style.backButton}
                onClick={() =>
                    navigateToStep(ApplicationPaths.sign, applicationId, navigate, applicantId)
                }
            > {"< "}Tilbake </span>
        <div className={style.wrapper}>
            
            <Headline>Dokumenter lastes opp</Headline>
                {<Hero ui="secondary">Fullfører, vennligst vent</Hero>         
            }
             {errorMsg ? <ErrorMessage>{errorMsg}</ErrorMessage> : null}
            </div>
        </>
    );
}

export default SblCompleted;